<script lang="ts">
	import { format } from 'svelte-i18n';
	import {
		ControlsContainer,
		DoubleDeviceButton,
		DeviceButton,
		Text,
	} from '@Shelly/shelly-design-system';
	import { format_temp_units } from '../../../../../helpers/utilities';
	import { createEventDispatcher } from 'svelte';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import ChooseThermostatState from './ChooseThermostatState.svelte';

	export let units, value, mode, disabled;

	const dispatch = createEventDispatcher();

	const handle_thermostat_state_change = (e) => {
		disabled = e.detail.disabled;
		dispatch('change_thermostat_state', { disabled });
	};

	const handle_count = (direction: 'up' | 'down') => {
		let _val = value;
		_val =
			direction === 'up'
				? Number(Number(_val) + 1).toFixed(2)
				: Number(Number(_val) - 1).toFixed(2);
		dispatch('temp_change', { value: _val });
	};
</script>

<ChooseThermostatState {disabled} on:thermostatStateChange={(e) => handle_thermostat_state_change(e)} />
<ControlsContainer color={$showNewLayout ? 'color-1' : undefined}>
	<svelte:fragment slot="first">
		<DoubleDeviceButton
			id="doubledevicebutton-482sp3i"
			aria-label={$format('label_temperature_controls', { default: 'Temperature Controls' })}
			size="l"
			class="align-self-center"
			{disabled}
		>
			<DeviceButton
				{disabled}
				id="devicebutton-m8chv35"
				aria-label={$format('button_decrease_temperature', { default: 'Decrease temperature' })}
				size="l"
				slot="buttonLeft"
				icon="fas fa-minus"
				variant="primary"
				on:touchstart={() => {}}
				on:click={() => handle_count('down')}
			/>
			<svelte:fragment slot="content">
				<Text styleType="controls-large" class="text-bold">
					{value}
				</Text>
				<Text styleType="controls-small">{`${format_temp_units(units)}`}</Text>
			</svelte:fragment>
			<DeviceButton
				{disabled}
				id="devicebutton-1zcjsx1"
				aria-label={$format('button_increase_temperature', { default: 'Increase temperature' })}
				size="l"
				slot="buttonRight"
				icon="fas fa-plus"
				variant="danger"
				on:touchstart={() => {}}
				on:click={() => handle_count('up')}
			/>
		</DoubleDeviceButton>
		<Text class="mt-s">{$format(`mode_${mode}`)}</Text>
	</svelte:fragment>
</ControlsContainer>
